module.exports = __webpack_public_path__ + "img/img7.7e9a37e2.png";